module.exports = __webpack_public_path__ + "assets/img/logo1.b9db61ba.png";